<template>
    <div class="stock_item">
        <header>{{item.company.projectName}}</header>
        <div class="row">
            <div class="col s12">
                <ul class="tab">
                    <li
                        @click.stop="changeType('option')"
                        class="col s6"
                    >
                        <a :class="this.type=='option'?'active':''">{{'期权'|language}}</a>
                    </li>
                    <li
                        @click="changeType('rsu')"
                        class="col s6"
                    >
                        <a :class="this.type=='rsu'?'active':''">{{'限售股'|language}}</a>
                    </li>
                </ul>
            </div>
            <div
                id="test1"
                class="col s12"
                v-if="this.type=='option'"
            >
                <ul>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/ab472f90-83b1-11e9-80d7-2130fd75019b.svg"
                                alt
                            />
                            <span>{{'授予总数'|language}}</span>
                        </div>
                        <p>{{data.total}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5be40d0-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'参考每股价格'|language}}</span>
                        </div>
                        <p>{{sellPrice}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/ab46ba60-83b1-11e9-80d7-2130fd75019b.svg"
                                alt
                            />
                            <span>{{'可行权'|language}}</span>
                        </div>
                        <p>{{data.kxq === undefined? 0: data.kxq}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5c01590-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'已行权'|language}}</span>
                        </div>
                        <p>{{data.yxq === undefined? 0: data.yxq}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/ab470880-83b1-11e9-80d7-2130fd75019b.svg"
                                alt
                            />
                            <span>{{'未行权'|language}}</span>
                        </div>
                        <p>{{data.wcs === undefined? 0: data.wcs}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5bf2b30-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'已回收'|language}}</span>
                        </div>
                        <p>{{data.yhs === undefined? 0: data.yhs}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5be40d0-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'可变现估值'|language}}</span>
                        </div>
                        <p>{{bianxianPrice}}</p>
                    </li>
                    <li class="col s6">
                        <a
                            class="waves-effect waves-light btn orange"
                            @click="bianxian"
                        >{{'我想变现'|language}}</a>
                    </li>
                </ul>
            </div>
            <div
                id="test2"
                class="col s12"
                v-else-if="this.type=='rsu'"
            >
                <ul>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/ab472f90-83b1-11e9-80d7-2130fd75019b.svg"
                                alt
                            />
                            <span>{{'授予总数'|language}}</span>
                        </div>
                        <p>{{data.total}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5be40d0-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'参考每股价格'|language}}</span>
                        </div>
                        <p>{{sellPrice}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5c01590-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'已解禁'|language}}</span>
                        </div>
                        <p>{{data.yjj === undefined? 0: data.yjj}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/ab470880-83b1-11e9-80d7-2130fd75019b.svg"
                                alt
                            />
                            <span>{{'未解禁'|language}}</span>
                        </div>
                        <p>{{data.wjj === undefined? 0: data.wjj}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5bf2b30-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'已回收'|language}}</span>
                        </div>
                        <p>{{data.yhs === undefined? 0: data.yhs}}</p>
                    </li>
                    <li class="col s6">
                        <div>
                            <img
                                src="http://static.unicornselected.com/b5be40d0-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                            <span>{{'可变现估值'|language}}</span>
                        </div>
                        <p>{{bianxianPrice}}</p>
                    </li>
                    <li class="col s6">
                        <a
                            class="waves-effect waves-light btn modal-trigger orange"
                            @click="bianxian"
                        >{{'我想变现'|language}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div
            class="row"
            style="padding-bottom: 1rem"
        >
            <div class="col s10">
                &nbsp;&nbsp;
            </div>
            <div class="col s1">
                <div class="edit">
                    <a
                        class="waves-effect waves-light"
                        @click="showDialog"
                    >
                        <img
                            src="http://static.unicornselected.com/b5be67e0-838e-11e9-9b7a-bf944c367467.svg"
                            alt
                        />
                    </a>
                </div>
            </div>
            <div class="col s1">
                <div class="add">
                    <a
                        @click="addStock"
                        class=" btn-floating btn-small  waves-effect waves-light red"
                    ><i class="material-icons">add</i></a>
                </div>
            </div>

        </div>
        <div v-if="stateE">
            <editDialog
                ref="editDialog"
                :type="type"
                :item="content"
                @changeType="InnerTypeChange"
                @showInfo="showInfo"
            ></editDialog>
        </div>
        <div v-if="dialog1">
            <simple-dialog
                :content="en?'Please go to the personal center to supplement your personal information. The intention will be processed first after the certification':'请前往个人中心补充个人信息，认证后意向将会被优先处理'"
                @confirm="toMyInfo"
                @cancel="dialog1 = false"
            />
        </div>
        <div v-if="dialog2">
            <simple-dialog
                :content="'感谢您的意向，平台工作人员会与您取得联系以便后续对接' | language"
                :showCancel="false"
                :confirm-text="'关闭'"
                @confirm="dialog2 = false"
                @cancel="dialog2 = false"
            />
        </div>
        <div v-if="dialog3">
            <StockDialog
                ref="dialog3"
                @closed="close"
                @submited="submited"
            ></StockDialog>
        </div>
    </div>
</template>

<script>
import { toast } from '../../util/alert';
import { HttpClient } from '../../util/http.js';
import simpleDialog from '../dialog/simpleDialog';
import { NumberUtil } from '../../util/number';
import { defaultbus } from '../../util/bus.js';
import editDialog from '../../components/dialog/editDialog';
import StockDialog from '../../components/dialog/StockDialog';
export default {
    name: 'stockItem',
    data() {
        return {
            type: this.item.stocks[0].type,
            dialog1: false,
            dialog2: false,
            dialog3: false,
            authAlert: false,
            state: false,
            stateE: false,
            content: this.item,
        };
    },
    components: {
        simpleDialog,
        editDialog,
        StockDialog,
    },
    props: {
        item: {
            type: Object,
        },
        page: {
            type: String,
        },
    },
    watch: {},
    computed: {
        en() {
            return location.pathname.indexOf('/en') == -1 ? '' : '/en';
        },
        company() {
            return this.item.company;
        },
        data() {
            return this.item[this.type];
        },
        fact() {
            return (this.company.sellFact || 100) / 100;
        },
        sellPrice() {
            if (!this.company.sellValueTypePerStock)
                return this.en ? 'none' : '暂无';
            let prefix = this.company.sellValueTypePerStock === 1 ? '¥' : '$';
            return `${prefix}${Number(
                this.company.sellValuePerStock * this.fact,
            ).toFixed(2)}`;
        },
        bianxianPrice() {
            if (!this.company.sellValueTypePerStock)
                return this.en ? 'none' : '暂无';
            let prefix = this.company.sellValueTypePerStock === 1 ? '¥' : '$';
            return `${prefix}${Number(
                this.company.sellValuePerStock *
                    this.fact *
                    (this.type == 'option' ? this.data.yxq : this.data.yjj),
            ).toFixed(2)}`;
        },
    },
    created() {
        if (this.item.option.total) {
            this.type = 'option';
        } else {
            this.type = 'rsu';
        }
    },
    methods: {
        changeType(type) {
            if (!this.item[type].total) {
                return toast(
                    this.en ? 'No record has been added' : '还没有添加记录',
                );
            }
            this.type = type;
        },
        showDialog() {
            if (
                this.content.hasOwnProperty('stocks') &&
                this.content.stocks.length > 0
            ) {
                this.stateE = true;
                this.$emit('changeState', true);
            } else {
                toast(this.en ? 'Please add record first' : '请先添加记录');
            }

            // this.company = company;
            // this.stocks = stocks[0];
        },
        closeAll() {
            this.dialog1 = false;
            this.dialog2 = false;
            this.dialog3 = false;
            this.stateE = false;
        },
        showInfo() {
            this.stateE = false;
            this.$emit('showInfo');
        },
        InnerTypeChange(type) {
            this.type = type;
            this.stateE = false;
            this.$nextTick(() => {
                this.$emit('showInfo');
            });
        },
        close() {
            this.dialog3 = false;
        },
        async bianxian() {
            this.authAlert = false;
            if (localStorage.getItem('djhusermodelpc1') === null) {
                toast(this.en ? 'Please login first' : '请先登录');
                return defaultbus.$emit('toggle-login');
            }
            let user = JSON.parse(localStorage.getItem('djhusermodelpc1'));
            if (!user.authentication) {
                try {
                    this.dialog1 = true;
                    return;
                } catch (e) {
                    this.authAlert = true;
                }
            }
            await HttpClient.put('/restful', {
                model: 'Bianxian',
                updates: {
                    user: user._id,
                    company: this.company._id,
                },
            });
            this.dialog2 = true;
        },
        toMyInfo() {
            this.$router.push('/main/my?active=5');
        },
        addStock() {
            this.dialog3 = true;
            this.$nextTick(() => {
                this.$refs.dialog3.init({
                    company: this.item.company._id,
                    type: this.item.stocks[0].type,
                });
            });
        },
        async submited(stock) {
            const res = await HttpClient.get('/stock/mine');
            this.content = res.filter(
                item => item.company._id == stock.company,
            )[0];
            this.dialog3 = false;
            this.$emit('showInfo');
        },
    },
};
</script>

<style lang="less" scoped>
.stock_item {
    border-radius: 5px;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    margin-bottom: 20px;
    header {
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        text-align: left;
        padding-left: 50px;
    }
    .tab li {
        height: 50px;
        line-height: 50px;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        .active {
            display: block;
            width: 100%;
            height: 100%;
            font-size: 16px;
            color: #bc242b;
            border-bottom: 1px solid #bc242b;
        }
        a {
            color: #000;
            font-size: 16px;
        }
        i {
            display: block;
            width: 20px;
            height: 20px;
        }
    }
    #test1,
    #test2 {
        padding: 20px 0;
        border-bottom: 1px solid #ddd;
        li {
            div {
                width: 150px;
                white-space: nowrap;
                height: 20px;
                margin: 0 auto;
                img {
                    float: left;
                    width: 20px;
                }
                span {
                    float: right;
                    width: 100px;
                    text-align: left;
                }
            }
        }
    }
    .active {
        color: #bc242b;
        border-bottom: 1px solid #bc242b;
    }
    .add {
        display: inline-block;
        /*width: 20px;*/
        a {
            /*width: 20px;*/
            /*height: 20px;*/
            i {
                width: 20px;
                height: 20px;
            }
        }
    }
    .edit {
        display: inline-block;
        height: 30px;
        padding-right: 30px;
        img {
            width: 32px;
        }
    }
}
</style>
